import createTypes from 'redux-create-action-types';

export const asyncActionTypeRequest = (baseAction) => `${baseAction}_REQUEST`;
export const asyncActionTypeSuccess = (baseAction) => `${baseAction}_SUCCESS`;
export const asyncActionTypeFailure = (baseAction) => `${baseAction}_FAILURE`;

export default createTypes(
  'GET_TICMART_JOBS',
  'GET_TICMART_ASSIGNED_JOBS',
  'CHANGE_PARAMS_TICMART_JOBS',
  'CHANGE_PARAMS_ASSIGNED_JOBS',
  'SELECT_TICMART_JOB',
  'SELECT_ALL_TICMART_JOB',
  'RESET_SELECTED_TICMART_JOB',

  // new assign
  'CHANGE_JOBS_TO_ASSIGN',
  'REMOVE_JOB_TO_ASSIGN',
  'RESET_JOB_TO_ASSIGN',
  'GET_EXISTING_JOBS_MODAL',
  'CHANGE_PARAMS_EXISTING_JOBS_MODAL',
  'RESET_PARAMS_EXISTING_JOBS_MODAL',
  'SELECT_EXISTING_JOBS_MODAL',
  'SELECT_ALL_EXISTING_JOBS_MODAL',
  'SELECT_SERVICE_PROVIDER',
  'GET_SERVICE_PROVIDERS_ASSIGN_JOB',
  'RESET_SERVICE_PROVIDER',

  //edit
  'GET_JOB_DETAIL',
  'RESET_JOB_DETAIL'
);
